import { Grid, ListItem, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import CreateBillWithLineItemsDialog from '~/modules/billing-invoicing/billingItem/CreateBillWithLineItemsDialog';
import { useDialogState } from '~/modules/common/hooks';
import { useAvailableToBillListTableContext } from '~/modules/billing-invoicing/common/hooks';
import { MobileBillingTransactionAmountRow } from '../MobileBillingTransactionListItem/components';
import {
  MobileAvailableToBillHeaderRow,
  MobileAvailableToBillProjectRow
} from './components';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(1)
  },
  grid: {
    padding: theme.spacing(0, 1)
  }
}));

export const MobileAvailableToBillListItemInternal = memo(
  ({ record, enabledColumns }) => {
    const classes = useStyles();
    const { editable, projectContext } = record;
    const { open, openDialog, closeDialog } = useDialogState(false);

    const onCardClickHandler = useCallback(() => {
      editable && openDialog();
    }, [editable, openDialog]);

    const { refetchAvailableToBillRows } = useAvailableToBillListTableContext();

    return (
      <>
        <ListItem
          button
          onClick={onCardClickHandler}
          className={classes.container}
        >
          <Grid
            className={classes.grid}
            container
            direction="column"
            wrap="nowrap"
            component={Paper}
            square
            elevation={0}
          >
            <Grid item>
              <MobileAvailableToBillHeaderRow record={record} />
              <MobileAvailableToBillProjectRow
                record={record}
                enabledColumns={enabledColumns}
              />
              <MobileBillingTransactionAmountRow
                balanceAmount={record.amount}
              />
            </Grid>
          </Grid>
        </ListItem>
        {open && (
          <CreateBillWithLineItemsDialog
            open
            {...record}
            onClose={closeDialog}
            projectName={projectContext.projectName}
            refetchAvailableToBillRows={refetchAvailableToBillRows}
            projectUri={projectContext.projectUri}
          />
        )}
      </>
    );
  }
);

MobileAvailableToBillListItemInternal.propTypes = {
  record: PropTypes.object.isRequired,
  enabledColumns: PropTypes.array
};

const MobileAvailableToBillListItem = ({ enabledColumns }) => props => {
  // eslint-disable-next-line react/prop-types
  const { record } = props;

  return (
    <MobileAvailableToBillListItemInternal
      enabledColumns={enabledColumns}
      record={record}
    />
  );
};

MobileAvailableToBillListItem.propTypes = {
  enabledColumns: PropTypes.array
};

export default MobileAvailableToBillListItem;
